import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Des sites web statiques et dynamiques`}</h2>
    <p>{`Avec ou sans le `}<strong parentName="p">{`JAMStack`}</strong>{`, le futur est là. Grâce au pouvoir de JavaScript, React et des outils comme Gatsby et Next.js il est possible de réaliser des sites ultras rapides. Du simple `}<strong parentName="p">{`site vitrine`}</strong>{` à des `}<strong parentName="p">{`applications complexes`}</strong>{` avec gestion des autorisations. Les possibilités sont sans limites. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      